import React from "react";
import parse from "html-react-parser";
import "./index.css";
import { Container } from "react-bootstrap";

export default function Disclaimers({ data }) {
  const disclaimers = data?.disclaimer?.disclaimers;

  if (!disclaimers || disclaimers.length === 0) {
    return null;
  }

  return (
    <Container>
      <div className="disclaimers-wrapper">
        {disclaimers.map((disclaimer, index) => (
          <p key={index} className="disclaimer-text">
            {parse(disclaimer)}
          </p>
        ))}
      </div>
    </Container>
  );
}
